export default class DepartmentsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.departmentsEndpoint, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.departmentsEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.departmentsEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.departmentsEndpoint, {
      params
    })
  }
}
